/* Modulo FAQ Outline — accordion with smooth height transition + single/multi-open.
   Vanilla IIFE, lazy-init via window.moduloLazyInit when available. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(el) {
    if (el.dataset.foBound === '1') return;
    el.dataset.foBound = '1';

    var mode  = el.getAttribute('data-mode') === 'multi' ? 'multi' : 'single';
    var items = el.querySelectorAll('[data-modulo-fo-item]');

    function close(item) {
      var content = item.querySelector('[data-modulo-fo-content]');
      var trigger = item.querySelector('[data-modulo-fo-trigger]');
      item.classList.remove('modulo-fo__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (content) content.style.maxHeight = '0';
    }

    function open(item) {
      var content = item.querySelector('[data-modulo-fo-content]');
      var trigger = item.querySelector('[data-modulo-fo-trigger]');
      item.classList.add('modulo-fo__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-modulo-fo-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('modulo-fo__item--open');

        if (mode === 'single' && !isOpen) {
          items.forEach(function (other) { if (other !== item) close(other); });
        }

        if (isOpen) close(item);
        else        open(item);
      });
    });

    // Recalc max-height on resize so wrapped answers don't get clipped.
    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        items.forEach(function (item) {
          if (!item.classList.contains('modulo-fo__item--open')) return;
          var content = item.querySelector('[data-modulo-fo-content]');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      }, 100);
    }, { passive: true });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-fo]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-fo]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
